import { Controller } from "@hotwired/stimulus"

// Ensure the page is loaded in the top-level window
// Useful to break out of, for example, iframes
export default class extends Controller {
  connect () {
    if (window.location !== window.top.location) {
      window.top.location = window.location;
    }
  }
}
